import { render, staticRenderFns } from "./BPhoneNumberField.vue?vue&type=template&id=f74ab03e&scoped=true"
import script from "./BPhoneNumberField.vue?vue&type=script&lang=ts"
export * from "./BPhoneNumberField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74ab03e",
  null
  
)

export default component.exports